import { StanButton, StanModal } from '@/components';
import IcMoney from '@/assets/icons/ic-currency-dollar-circle.svg';
import IcCopy from '@/assets/icons/ic-copy.svg';
import { useModal } from '@/hooks/useModal';
import { cancelPaymentPlan, copyUpdateBillingDetailsLink } from '@/lib/api/income/api';
import { useState } from 'react';

export function PaymentPlanButtonArea({
    paymentPlanId,
    onPaymentPlanUpdate,
}: {
    paymentPlanId: string;
    onPaymentPlanUpdate: () => void;
}) {
    const { isOpen: isPaymentPlanModalOpen, open: openPaymentPlanModal, close: closePaymentPlanModal } = useModal();
    const [isCopyBillingLinkLoading, setIsCopyBillingLinkLoading] = useState(false);

    return (
        <>
            <StanButton
                name='payment-details-cancel-payment-plan-button'
                variant='outline'
                icon={IcMoney}
                onClick={openPaymentPlanModal}
                size='xs'
                color='secondary'
                className='w-full md:w-fit'
            >
                Cancel Payment Plan
            </StanButton>
            <StanButton
                name='payment-details-copy-billing-payment-plan-button'
                variant='outline'
                icon={IcCopy}
                onClick={() => {
                    setIsCopyBillingLinkLoading(true);
                    copyUpdateBillingDetailsLink(paymentPlanId).finally(() => setIsCopyBillingLinkLoading(false));
                }}
                size='xs'
                color='secondary'
                className='w-full md:w-fit'
                loading={isCopyBillingLinkLoading}
            >
                Copy Billing Link
            </StanButton>
            <StanModal
                id='manage-payment-plan-modal'
                isOpen={isPaymentPlanModalOpen}
                onClose={closePaymentPlanModal}
                title='Cancel Payment Plan'
                primaryActionLabel='Cancel Payment Plan'
                primaryActionColor='destructive'
                onPrimaryAction={() =>
                    cancelPaymentPlan(paymentPlanId).finally(() => {
                        onPaymentPlanUpdate();
                        closePaymentPlanModal();
                    })
                }
                secondaryActionColor='secondary'
                secondaryActionLabel='Keep It!'
                onSecondaryAction={closePaymentPlanModal}
            >
                <span className='text-light flex items-center justify-center p-3 text-center text-sm'>
                    Cancelling this plan will stop all future payments. This does not affect any previous payments.
                </span>
            </StanModal>
        </>
    );
}
